import React, {memo, useState, useCallback, useEffect, useRef} from 'react';
import {MIDI_FX, OSCILLATOR} from 'constants/effect-types.js';
import { connect } from "react-redux";
import { Group} from 'react-konva';
import NodeIO from './NodeIO.js';
import {
    INPUT,
    OUTPUT,
    NODE_WIDTH,
    NODE_COLOR,
    NODE_HEIGHT} from './constants.js';

const NodeIOs = memo(( {
    effect,
    x,
    y,
    setDragging,
    rack,
    connectEdge,
    startDrawingEdge,
    drawingEdge,
    selectedEdge,
    setSelectedEdge,
    edges,
    isMacroMapping
}) => {
    let num = Math.floor(effect.numberOfOutputs);
    if (isNaN(num)) {
        num = 1;
    }
    let outputs = new Array(num).fill(undefined);
    let inputs = [undefined];
    
        if (effect.parameters) {
            if (rack.getEffectType() === OSCILLATOR) {
                inputs = [
                    ... inputs,
                ];
            } else {
                inputs = [
                    ... inputs,
                    ... effect.parameters
                        .filter(x => x.automatable)
                        .filter(x => x.name !== 'enabled')
                ];
            }
        }
        if (inputs.length > 15) {
            inputs = inputs.slice(0, 15);
        }

        return (
            <g>
              {inputs.map(
                  (n,i) => 
                      <NodeIO
                        x={x}
                        y={y}
                        key={'intput-' + i}
                        number={i+1}
                        mode={INPUT}
                        selectedEdge={selectedEdge}
                        parameter={n}
                        effect={effect}
                        isMacroMapping={isMacroMapping}
                        rack={rack}
                        connectEdge={connectEdge}
                        drawingEdge={drawingEdge}
                        startDrawingEdge={startDrawingEdge}
                      />)}
              {outputs.map(
                  (n,i) =>
                      <NodeIO
                        key={'output-' + i}
                        x={x}
                        y={y}
                        parameter={n}
                        drawingEdge={drawingEdge}
                        rack={rack}
                        selectedEdge={selectedEdge}
                        number={i+1}
                        mode={OUTPUT}
                        connectEdge={connectEdge}
                        startDrawingEdge={startDrawingEdge}
                        effect={effect}
                      />)}
            </g>
        );
    });

const mapStateToProps = (state, props) => {
    if (props.x !== undefined) {
        return {};
    }
    return {
        x: props.effect.x,
        y: props.effect.y,
        isMacroMapping: state.effects.isMacroMapping,
        numberOfOutputs: props.effect.numberOfOutputs
    };
};

export default connect(mapStateToProps, null)(NodeIOs);
